import script from "./VendorOnBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorOnBoard.vue?vue&type=script&setup=true&lang=js"

import "./VendorOnBoard.vue?vue&type=style&index=0&id=0b6c09ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6c09ce"]])

export default __exports__